

class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
  
      if (!this.slider) return;
      
      this.initPages();
  
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
    }
    
    
    initPages() {
      const sliderActive = this.slider.id;
      
      $('#' + sliderActive).not('.slick-initialized').slick({
        prevArrow: '<span class="slick-btn slick-prev slick-arrow"><svg width="27" height="30" viewBox="0 0 27 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.5 2L3 24.5L25.5 47" stroke="#000" stroke-width="3"/></svg></span>', 
        nextArrow: '<span class="slick-btn slick-next slick-arrow"><svg width="27" height="30" viewBox="0 0 27 49" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 47L24.5 24.5L2 2" stroke="#000" stroke-width="3"/></svg></span>'
      
        });
      }
    }
    
customElements.define('slideshow-component', SlideshowComponent);



(function($) {
  this.MobileNav = function() {
          this.curItem,
                  this.curLevel = 0,
                  this.transitionEnd = _getTransitionEndEventName();

          var defaults = {
                  initElem: ".main-menu",
                  menuTitle: "Menu"
          }

          // Check if MobileNav was initialized with some options and assign them to the "defaults"
          if (arguments[0] && typeof arguments[0] === "object") {
                  this.options = extendDefaults(defaults, arguments[0]);
          }

          // Add to the "defaults" ONLY if the key is already in the "defaults"
          function extendDefaults(source, extender) {
                  for (option in extender) {
                          if (source.hasOwnProperty(option)) {
                                  source[option] = extender[option];
                          }
                  }
          }

          MobileNav.prototype.getCurrentItem = function() {
                  return this.curItem;
          };

          MobileNav.prototype.setMenuTitle = function(title) {
                  defaults.menuTitle = title;
                  _updateMenuTitle(this);
                  return title;
          };

          // Init is an anonymous IIFE
          (function(MobileNav) {
                  var initElem = ($(defaults.initElem).length) ? $(defaults.initElem) : false;

                  if (initElem) {
                          defaults.initElem = initElem;
                          _clickHandlers(MobileNav);
                          _updateMenuTitle(MobileNav);
                  } else {
                          console.log(defaults.initElem + " element doesn't exist, menu not initialized.");
                  }
          }(this));

          function _getTransitionEndEventName() {
                  var i,
                          undefined,
                          el = document.createElement('div'),
                          transitions = {
                                  'transition': 'transitionend',
                                  'OTransition': 'otransitionend', // oTransitionEnd in very old Opera
                                  'MozTransition': 'transitionend',
                                  'WebkitTransition': 'webkitTransitionEnd'
                          };

                  for (i in transitions) {
                          if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
                                  return transitions[i];
                          }
                  }
          };

          function _clickHandlers(menu) {
                   $('body').on('click', '.has-dropdown > a', function(e) {
                          e.preventDefault();
                          $('body').removeClass('unloading');
                          menu.curItem = $(this).parent();
                          _updateActiveMenu(menu);
                  });

                  $('body').on('click', '.nav-toggle', function() {
                    $('body').removeClass('unloading');
                          _updateActiveMenu(menu, 'back');
                        
                  });
          };

          // TODO: Make this DRY (deal with waiting for transitionend event)
          function _updateActiveMenu(menu, direction) {
                  _slideMenu(menu, direction);
                  if (direction === "back") {
                          /*defaults.initElem.children('ul').one(menu.transitionEnd, function(e) {
                                  menu.curItem.removeClass('nav-dropdown-open nav-dropdown-active');
                                  menu.curItem = menu.curItem.parent().closest('li');
                                  menu.curItem.addClass('nav-dropdown-open nav-dropdown-active');
                                  _updateMenuTitle(menu);
                          });*/

                          $('body').removeClass('unloading');

                          menu.curItem.removeClass('nav-dropdown-open nav-dropdown-active');
                          menu.curItem = menu.curItem.parent().closest('li');
                          menu.curItem.addClass('nav-dropdown-open nav-dropdown-active');
                          _updateMenuTitle(menu);
                  } else {
                       $('body').removeClass('unloading');
                          menu.curItem.addClass('nav-dropdown-open nav-dropdown-active');
                          _updateMenuTitle(menu);
                  }
          };

          // Update main menu title to be the text of the clicked menu item
          function _updateMenuTitle(menu) {
             
                  if (menu.curLevel > 0) {
                    
                          $('.nav-toggle').addClass('back-visible');
                          $('body').removeClass('unloading');
                  } else {
                    $('body').removeClass('unloading');
                          $('.nav-toggle').removeClass('back-visible');
                  }
               
          };

          // Slide the main menu based on current menu depth
          function _slideMenu(menu, direction) {
                  if (direction === "back") {
                          menu.curLevel = (menu.curLevel > 0) ? menu.curLevel - 1 : 0;
                  } else {
                          menu.curLevel += 1;
                  }
                  defaults.initElem.children('ul').css({
                          "transform": "translateX(-" + (menu.curLevel * 100) + "%)"
                  });
          };
  }
}(jQuery));
    


$(function() {
    "use strict";

	var body = $("body");
	

function handleTabNavigation($clickedTab, e) {
    if (e) {
      e.preventDefault(); // Prevent default browser behavior
      e.stopPropagation(); // Stop event bubbling
    }
    
    var url = $clickedTab.data("href");
    
    // Don't do anything if no URL
    if (!url || url === "#") {
      return;
    }
    
    // Only remove active class from tabs in the same container
    var $container = $clickedTab.closest(".tab-slider--nav");
    $container.find("li").removeClass("active");
    
    // Add active class to clicked tab (CSS makes this instant)
    $clickedTab.addClass("active");
    
    // Redirect immediately - browser will render one frame with active state
    window.location.href = url;
  }

  // Click handler (desktop)
  $(".tab-slider--nav li").on("click", function(e) {
    handleTabNavigation($(this), e);
  });

  // Touch handlers (mobile)
  $(".tab-slider--nav li").on("touchstart", function(e) {
    var $tab = $(this);
    // Add touching class for instant visual feedback
    $tab.addClass("touching");
    // Prevent default to avoid delay
    e.preventDefault();
  });

  $(".tab-slider--nav li").on("touchend", function(e) {
    var $tab = $(this);
    // Remove touching class
    $tab.removeClass("touching");
    // Handle navigation
    handleTabNavigation($tab, e);
  });

  // Fallback: remove touching class if touch is cancelled
  $(".tab-slider--nav li").on("touchcancel", function(e) {
    $(this).removeClass("touching");
  });


  var selectorChange = $('.single-option-selector');



  selectorChange.each(function( index ) {
    var target = $( this ).find(':selected').data('variation');

    if(target == false ){
      $(this).parents('.LinkedProduct').find('.add-to-link-cart').text('Sold out');
      $(this).parents('.LinkedProduct').find('.add-to-link-cart').addClass('deseable');
    }else{
      $(this).parents('.LinkedProduct').find('.add-to-link-cart').text('ADD');
      $(this).parents('.LinkedProduct').find('.add-to-link-cart').removeClass('deseable');
    }

    $(this).on('change', function() {
      var target2 = $( this ).find(':selected').data('variation');
      var price = $( this ).find(':selected').data('price');
      var vareint_image = $( this ).find(':selected').data('varient-image');
      var target_v_image = $( this ).parents('.LinkedProduct').find('.pactive');
      var variation_item = $( this ).val();
  

      target_v_image.find('img').attr('src', vareint_image);

      if(target2 == false ){
        $(this).parents('.LinkedProduct').find('.price').text(price);
        $(this).parents('.LinkedProduct').find('.payment-buttons').removeClass('disabled');
        $(this).parents('.LinkedProduct').find('.add-to-link-cart').addClass('disabled');
      }else{


        $(this).parents('.LinkedProduct').find('.payment-buttons').addClass('disabled');
        $(this).parents('.LinkedProduct').find('.price').text(price);
        $(this).parents('.LinkedProduct').find('.add-to-link-cart').removeClass('disabled');
      }
    });

  });




   var VariantSelector = $('.variant-input-wrap select').find(":selected").val();
   var product__thumbs = $('.product__thumbs--scroller').find(".product__thumb-item");
   var v_color = $('input[name=Color]:checked').val();


   var product_main_varient  = $('.product-main-varient');
   


   if(v_color != undefined || v_color != null  ){


    var newVariantName = VariantSelector+" / "+v_color;
 
    product__thumbs.each(function() {
     var all_product__thumb = $(this).data("image");
          if(all_product__thumb == newVariantName) {
           $(this).addClass('active')
          }
    });

 
    

   }else{

    var newVariantName = VariantSelector;
 
    product__thumbs.each(function() {
     var all_product__thumb = $(this).data("image");
          if(all_product__thumb == newVariantName) {
           $(this).addClass('active')
          }
    });


   }





        $(".variant-measurement").on('click', function() {

            $(".variant-measurement").removeClass('active_color');
            $(this).addClass('active_color');

            var targetSrc = $('.product-main-slide.is-selected');

            $(this).each(function(element) {
                if($(this).hasClass('active')){
                var imageSrc  =  $(this).find('img').attr('src');

                 targetSrc.find('img').attr("src",imageSrc);
                 targetSrc.find('img').attr("srcset",imageSrc);
                 targetSrc.find('img').attr("data-photoswipe-src",imageSrc);
            }
            
            });

       
        });


        $(document).ready(function() {
          var owl = $('.owl-carousel');
          if(owl.length > 0){

            owl.owlCarousel({
              margin: 10,
              nav: true,
              loop: false,
              responsive: {
                0: {
                  items: 4
                },
                600: {
                  items: 7
                },
                1000: {
                  items: 10
                }
              }
            })

            
          }


         
        });


          


        var addToCart = $('a[data-signup="signup"]');
        var closePopup = $('.cd-popup-close');
    
        addToCart.each(function(e) {
          var self = $(this);
         

          self.on('click', function(event) {
            var popupProduct = $(this).parents('.grid__item').find('.product_sign_up');
            event.preventDefault();
            body.removeClass('unloading');
            
            if(!popupProduct.hasClass('is-visible')){
              popupProduct.addClass('is-visible');
            }else{
              popupProduct.removeClass('is-visible');
              body.removeClass('unloading');
            }
  
            });
  
      
        });
        closePopup.each(function(e) {
                var self = $(this);
                self.on('click', function(event) {
            var popupProduct = self.parents('.product_sign_up');
            event.preventDefault();
            body.removeClass('unloading');
            if(popupProduct.hasClass('is-visible')){
                popupProduct.removeClass('is-visible');
            }else{
                popupProduct.addClass('is-visible');
            }
        
            });

        });


        $(document).click(function (e) {
                if ($(e.target).is('div.cd-popup.product_sign_up.is-visible')) {
                 $('.product_sign_up').removeClass('is-visible');
                }
            });
      
      
  
     var MobileMenu = new MobileNav({
              initElem: "nav",
              menuTitle: "Push menu demo",
      });
  
      $('.js-nav-toggle').on('click', function(e) {
          e.preventDefault();
          body.removeClass('unloading');
          $('body').toggleClass('show-menu');
          $('.nav-wrapper').toggleClass('show-menu');
      });


//       var datajson = document.querySelector('textarea[data-variant-json]');

//       if(datajson != null){

//         var product_encodedObject = datajson.textContent;
//         var variants = JSON.parse(product_encodedObject);
    
//         let userSelectValues = [...variants];

//         console.log("variants", variants);
    

//       }


//       var cardVarientSlector = $('.grid-product__content');

//       cardVarientSlector.each(function (index) {
//         var product_encodedObject = this.querySelector('textarea[data-variant-json]').textContent;
//          var variants = JSON.parse(product_encodedObject);
//          let userSelectValues = [...variants];

//          var select = $(this).find(".variant-input-wrap select");

//            var selected_value =  select.find(":selected").val()

//            if(selected_value != undefined){
        
               
//               userSelectValues = [];
//               userSelectValues.push(selected_value);


//                 let matchedVariants = variants.find(variant => {
//                         let match = true;
                            
//                         for (let i = 0; i < userSelectValues.length; i++) {
//                             if (userSelectValues.indexOf(variant.options[i]) == -1) {
//                                 match = false;
//                                 break;
//                             }
//                         }
                        
//                         return match;
//                     });

//                     var image =  $(this).find('.custom_images img');

//                     if(image != null && matchedVariants.featured_image != null){
//                         image.attr("src",matchedVariants.featured_image.src);
//                         replace_srcset(image, matchedVariants.featured_image.src);
//                       }

//                     console.log("image", image);
//                     console.log("variants", matchedVariants);

//            }

//       });

	
});

// $(window).on("resize orientationchange", function() {
//   $(".slick").slick("resize");
//   $(".slick").slick('setPosition');
// });


// function replace_srcset(target, replacement){

//         var final_srcset = replacement+'360w,'+replacement+'540w,'+replacement+'720w,'+replacement+'1000w';

//         target.attr('srcset', final_srcset);

// }